import { render, staticRenderFns } from "./SelectedProductTable.vue?vue&type=template&id=432b2a8e&scoped=true&"
import script from "./SelectedProductTable.vue?vue&type=script&lang=js&"
export * from "./SelectedProductTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProductTable.vue?vue&type=style&index=0&id=432b2a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432b2a8e",
  null
  
)

export default component.exports